import React, { useEffect, useState } from "react";
import Icon from "../../../elements/icons/Icon";
import _ from 'lodash';

const colorList = [
    "#f34d2f",
    "#3096a5",
    "#ffa21b",
    "#226974",
    "#3aaa35",
    "#af60a2",
    "#95c11f",
    "#ab8cc0",
    "#7e6b5d",
    "#cba675",
    "#89ccca"
];

function toDecimal(value){
    return Number.parseFloat(value.toFixed(2))
}

export const People = props => {
    const { groups } = props,
        firstAnswer = groups[0],
        secondAnswer = groups[1];

    return (
        <div className="people">
            <Person {...firstAnswer} first />
            <Person {...secondAnswer} />
        </div>
    );
};
const Person = ({ percentage_of_total, group_label, first }) => (
    <div>
        <Icon
            src={"/img/human_green.png"}
            size={percentage_of_total + 50}
            color={first ? "limegreen" : "#f34d2f"}
        />
        <p className="percentage">{toDecimal(percentage_of_total) + "%"}</p>
        <p>{group_label}</p>
    </div>
);

export const Graph = props => {
    const { groups} = props;
    return (
        <div className="graphContainer">
            {groups.map((option, index) => (
                <Bar
                    key={option.group_key}
                    percentage={option.percentage_of_total}
                    color={colorList[index]}
                    index={index}
                />
            ))}
        </div>
    );
};
const Bar = ({ percentage = 0, color, index }) => {
    const [value, setValue] = useState(0);
    useEffect(() => setValue(percentage), [percentage]);
    return (
        <div
            className="bar"
            style={{
                height: value + "%",
                background: color,
                borderColor: color,
                transitionDelay: index * 100 + "ms"
            }}
        />
    );
};

export const Legends = props => {
    const { groups } = props;
    return (
        <div className="legends">
            {groups.map((option, index) => (
                <div key={option.group_label} >
                    <div
                        className="legendColor"
                        style={{ background: colorList[index] }}
                    />
                    <p className="percentage">
                        {toDecimal(option.percentage_of_total) + "%"}
                    </p>
                    <p>{option.group_label}</p>
                </div>
                // <Bar key={option.group_key} percentage={option.percentage_of_total} color={colorList[index]} index={index} />
            ))}
        </div>
    );
};


export const TextAnswerList = (props)=>{
    const {groups}= props;

    return (

        <ul className="textAnswer">
            {groups.map((answer, i) => (
                <li key={i} style={{animationDelay: i*50 +'ms'}} >{answer.group_label}</li>
            ))}
        </ul>
    )
}


